 
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { Button, ButtonGroup, TextField } from "@mui/material";

import { Paper } from "@mui/material";
import {
  fetchAllTitles,
 
} from "../../redux/features/titles.features";

const TitlesGrid = () => {
    let dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAllTitles());
      }, [dispatch]);

      let titlesState = useSelector((state) => {
        return state.titlesReducer;
      });
    
      let { titles } = titlesState;

      let iniitalColumns = [
        // {field:"id",headerName: "ID" },
      
        { field: "titlesName", headerName: "Titles Name", minWidth: 330, flex: 1 },
        {
          field: "titlesCategory",
          headerName: "Titles Category",
          minWidth: 330,
          flex: 1,
        },
        {
          field: "titlesDescription",
          headerName: "titles Description",
          minWidth: 330,
          flex: 1,
        },
        {
          field: "titlesStatus",
          headerName: "titles Status",
          minWidth: 330,
          flex: 1,
          renderCell: (cellValues) => {
            return (
              <Button
                variant="contained"
                color={
                  cellValues.row.titlesStatus === "Active" ? "primary" : "error"
                }
                onClick={(event) => {}}
              >
                {cellValues.row.titlesStatus}
              </Button>
            );
          },
        }
       
      ];
      
  return (
    <Box component={Paper} style={{ height: 350 }} className="">
    <DataGrid
      // getRowId={row => row._id}
      filterMode="client"
      rows={titles}
      columns={iniitalColumns}
      pageSize={15}
      rowsPerPageOptions={[15]}
      density="comfortable"
      className="col-12"
      autoPageSize
    />
  </Box>
  )
}

export default TitlesGrid